/* eslint-disable */
import firebase from "firebase/app";
import axios from "axios";
import "firebase/auth";

import { dayAgo } from "./helpers/dates";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const app = firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
});

export const auth = app.auth();

const getAuthHeaders = async () => {
  const currentUser = auth.currentUser;

  if (!currentUser) {
    throw new Error("Authentication is required");
  }

  const token = await currentUser.getIdToken();

  return {
    Authorization: `Bearer ${token}`,
  };
};

export const getAllUsers = async () => {
  const headers = await getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/firestore/project-users`, {
    headers,
  });

  return response.data;
};

export const handleAddUserToDb = async (projectId, userData, callback) => {
  try {
    const headers = await getAuthHeaders();

    await axios.post(
      `${BASE_URL}/firestore/project-users`,
      {
        projectId,
        userData,
      },
      { headers },
    );

    callback(projectId, userData);
  } catch (error) {
    console.log("Error getting document:", error);
  }
};

export const handleRemoveUserFromDb = async (projectId, userData, callback) => {
  try {
    const headers = await getAuthHeaders();

    await axios.delete(`${BASE_URL}/firestore/project-users/${projectId}`, {
      headers,
      data: {
        userData,
      },
    });

    callback(projectId, userData);
  } catch (error) {
    console.log("Error removing user from db:", error);
  }
};

export const handleUpdateUserInDb = async (
  projectId,
  objectToRemove,
  fieldsToUpdate,
  callback,
) => {
  try {
    const headers = await getAuthHeaders();
    const response = await axios.patch(
      `${BASE_URL}/firestore/project-users/${projectId}`,
      {
        objectToRemove,
        fieldsToUpdate,
      },
      { headers },
    );

    callback(projectId, response.data.users);
  } catch (error) {
    console.log("Error updating user in db:", error);
  }
};

export const getUnloggedUsers = async (time = dayAgo) => {
  try {
    const headers = await getAuthHeaders();
    const response = await axios.get(
      `${BASE_URL}/firestore/unlogged-users/${time}`,
      {
        headers,
      },
    );

    return response.data;
  } catch (error) {
    console.log("Error getting document:", error);
  }
};

export const handleRemoveUnloggedUser = async (
  userToRemove,
  callback,
  time = dayAgo,
) => {
  if (!userToRemove?.id) {
    return;
  }

  try {
    const headers = await getAuthHeaders();

    await axios.delete(`${BASE_URL}/firestore/unlogged-users/${time}`, {
      headers,
      data: {
        userToRemove,
      },
    });

    callback(userToRemove.id);
  } catch (error) {
    if (error?.response?.status === 404) {
      console.log("Not found in unlogged error: ", { error });
    }

    console.error("Error removing user from db:", { error });
  }
};

export default app;
